import { LocalStorageEnums } from 'src/shared/enums';
import { BrandColorsType, BrandConfigType } from 'src/shared/types/brand';

import { getLocalStorageValue } from './localStorage';

const SYNERION_BRAND: BrandColorsType = {
  primary: '#3B6EB7',
  primaryHover: '#4A91DC',
  secondary: '#E6F3FC',
  secondaryHover: '#C1E1F9',
  primaryDark: '#9DCFF5',
  primaryHoverDark: '#7ABBF0',
  secondaryDark: '#9DCFF5',
  secondaryHoverDark: 'rgba(255,255,255,0.08)',
};

const formatBrandColors = (brand: BrandColorsType): BrandConfigType => {
  return {
    light: {
      primary: brand.primary,
      primaryHover: brand.primaryHover || brand.primary,
      secondary: brand.secondary,
      secondaryHover: brand.secondaryHover || brand.secondary,
      logoUrl: brand.logoUrl,
      logoIconUrl: brand.logoIconUrl,
    },
    dark: {
      primary: brand.primaryDark || brand.primary,
      primaryHover: brand.primaryHoverDark || brand.primaryHover || brand.primary,
      secondary: brand.secondaryDark || brand.secondary,
      secondaryHover: brand.secondaryHoverDark || brand.secondaryHover || brand.secondary,
      logoUrl: brand.logoUrl,
      logoIconUrl: brand.logoIconUrl,
    },
  };
};

export function resolveBrandColors(mode: 'light' | 'dark', brand?: BrandColorsType): BrandColorsType {
  if (!brand) {
    return formatBrandColors(SYNERION_BRAND)[mode];
  }

  const brandConfig = formatBrandColors(brand);

  const config = brandConfig[mode];
  return {
    primaryHover: config?.primaryHover ?? config.primary,
    secondaryHover: config?.secondaryHover ?? config.secondary,
    ...config,
  };
}

const getStoredBrandConfig = (): BrandColorsType | null =>
  getLocalStorageValue(LocalStorageEnums.BRAND_CONFIG_SETTINGS);

export const getAppBrandConfigs = (mode: 'light' | 'dark') => {
  const brandConfig = getStoredBrandConfig();
  return resolveBrandColors(mode, brandConfig ?? SYNERION_BRAND);
};
